import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-black small text-center text-white-50">
      <div className="container">
        Copyright &copy; I'M LOHITH 2019
      </div>
    </footer>
  );
}
